import { useQuery } from '@tanstack/react-query';

import { API } from 'src/reactQuery/Api';
import { getRequest } from 'src/utils/request';
import { QUERY_KEYS } from 'src/reactQuery/QueryKeys';

import type { RequestDataArray } from 'src/types/requestData';

const mapProjectStatusOptions = (
  status: UCM.ProjectStatusOptionRawType,
  id: string,
): UCM.ProjectStatusOptionType => ({
  value: id,
  label: status.name,
});

const getProjectStatusOptions = async () => {
  const { data } = await getRequest<
    RequestDataArray<UCM.ProjectStatusOptionRawType>
  >(API.GET.projectStatusOptions);
  return data.data.map(({ attributes, id }) =>
    mapProjectStatusOptions(attributes, id),
  );
};

export const useGetProjectStatusOptions = (
  config: { enabled?: boolean } = { enabled: true },
) => {
  return useQuery({
    queryKey: [QUERY_KEYS.PROJECT_STATUS_OPTIONS],
    queryFn: getProjectStatusOptions,
    ...config,
  });
};
